module.exports = __webpack_public_path__ + "img/logo_聚享.e97ceaa8.png";